module.exports = __webpack_public_path__ + "img/process_3.4a246390.svg";